import { getAuth } from "firebase/auth";

/**
 * authFetch - A drop-in replacement for fetch() that automatically
 * attaches the Firebase ID token as an Authorization header.
 *
 * Waits for Firebase Auth to be ready before sending the request,
 * which prevents "no token provided" errors after page redirects.
 *
 * Falls back to a regular fetch if the user is not logged in.
 *
 * For FormData requests (file uploads), does NOT set Content-Type
 * so the browser handles multipart boundaries automatically.
 */
export async function authFetch(url, options = {}) {
    const auth = getAuth();
    
    // Wait for the initial authentication state to resolve globally 
    // (fixes the race condition on refresh/redirects)
    await auth.authStateReady();
    
    // Always fetch the freshest user state
    const user = auth.currentUser;

    const headers = new Headers(options.headers || {});

    if (user) {
        try {
            const token = await user.getIdToken();
            headers.set('Authorization', `Bearer ${token}`);
        } catch (error) {
            console.error('Failed to get ID token:', error);
        }
    }

    if (options.body instanceof FormData) {
        headers.delete('Content-Type');
    }

    return fetch(url, { ...options, headers });
}
